import Vue from 'vue'

// eslint-disable-next-line no-unused-vars
export default function (router) {
  Vue.swal({
    title: '<div style="color:#ed7d3e;">🚀 O Monitor Autônomo chegou trazendo mais liberdade na sua rotina!</div>',
    html: `
      <div style="color:rgb(25, 48, 81); font-size: 18px;">
        <br>
        Olá!
        <br><br>
        Com o Monitor Autônomo, os envios de documentos passam a acontecer de forma automática, direto para o cliente e sem necessidade de intervenção manual da sua equipe.
        <br><br>
        Você define o documento, configura a data do envio e o Monitor executa a rotina sozinho, todos os meses. Mais agilidade para o escritório, menos tarefas operacionais e menos risco de esquecimentos na entrega ao cliente.
        <br><br>
        A configuração já está disponível e leva poucos minutos.
        <br><br>
        <b>Clique em "Configurar" para acessar o Monitor Autônomo.</b>
        <br><br>
        <b>Atenciosamente, Equipe Monitor Contábil</b>
      </div>
    `,
    icon: 'warning',
    iconColor: '#ed7d3e',
    confirmButtonText: 'Configurar',
    showCancelButton: true,
    cancelButtonText: 'Fechar',
    reverseButtons: false,
    buttonsStyling: false,
    width: '35%',
    customClass: {
      popup: 'swal-m',
      confirmButton: 'btn btn-primary mt-2 mr-2',
      cancelButton: 'btn btn-danger mt-2 ml-2',
    },
  }).then(result => {
    if (result.isConfirmed) {
      router.push({ name: 'envio-automatico' })
    }
  })
}
